
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "@/components/shared/Logo";
import ThemeToggle from "@/components/layout/ThemeToggle";
import { ArrowRight } from "lucide-react";

interface ModernHeaderProps {
  className?: string;
}

const ModernHeader = ({ className }: ModernHeaderProps) => {
  return (
    <header className={`border-b border-gray-200/30 dark:border-gray-700/30 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm fixed top-0 left-0 right-0 z-50 ${className}`}>
      <div className="container max-w-7xl mx-auto flex justify-between items-center px-4 py-3">
        <Logo
          onClick={() => window.scrollTo(0, 0)}
          className="h-10 cursor-pointer"
        />
        <nav className="hidden md:flex items-center space-x-8">
          <a href="#features" className="text-gray-700 dark:text-gray-300 hover:text-nation-purple transition-all">Features</a>
          <a href="#how-it-works" className="text-gray-700 dark:text-gray-300 hover:text-nation-purple transition-all">How It Works</a>
          <a href="#join" className="text-gray-700 dark:text-gray-300 hover:text-nation-purple transition-all">Join Now</a>
        </nav>
        <div className="flex items-center gap-4">
          <ThemeToggle />
          <Button variant="purple" size="sm" asChild className="shadow-lg hover:shadow-xl transition-all">
            <Link to="/cards/KY" className="flex items-center gap-1">
              Access Platform <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default ModernHeader;
